const design = process.env.VUE_APP_DESIGN;

export default class Tool {
  static toRem(px) {
    return (px * 10) / design + "rem";
  }
  static loadingProcess(arr) {
    let i = 0;
    let total = arr.length;

    return function inner(cb, resolve) {
      if (total <= i) {
        resolve && resolve();
        return;
      }
      if (total && total > i) {
        let img = new Image();
        img.src = arr[i];
        img.onload = () => {
          cb && cb((i + 1) / total);
          i++;
          inner(cb, resolve);
        };
        img.onerror = () => {
          cb && cb((i + 1) / total);
          i++;
          inner(cb, resolve);
        };
      }
      // console.log(app.$el);
    };
  }
}
